import { ButtonType } from './../button/button.component';
import { Component, Input, OnInit } from '@angular/core';
import { ConfirmationModalService, ConfirmationModalType, IConfirmationModal } from '../../services/confirmation-modal.service';

@Component({
  selector: 'sigecom-confirmation-modal',
  template: `
    <div class="bg-sigecom-modal-dark/40 fixed inset-0 w-full h-full z-[130] flex justify-center items-center" *ngIf="isOpen">
  <div class="w-auto items-center justify-center min-w-[20%] px-5 py-4 max-h-[80%] max-w-[80%] absolute flex flex-col bg-white rounded-2xl animate-open-modal">

    <ng-container [ngSwitch]="args?.modalType">
      <fa-icon [icon]="'info'" class="text-sigecom-info text-5xl" *ngSwitchCase="modalType.info"></fa-icon>
      <fa-icon [icon]="'check'" class="text-sigecom-success text-5xl" *ngSwitchCase="modalType.success"></fa-icon>
      <fa-icon [icon]="'triangle-exclamation'" class="text-sigecom-danger text-5xl" *ngSwitchCase="modalType.danger"></fa-icon>
      <fa-icon [icon]="'triangle-exclamation'" class="text-sigecom-warn text-5xl" *ngSwitchCase="modalType.warn"></fa-icon>
    </ng-container>
    <header class="w-full h-10 flex justify-between items-center text-lg font-bold pl-2 pr-12 relative text-sigecom-gray" *ngIf="header">
      {{ header | titlecase }}
      <fa-icon>close</fa-icon>
    </header>



    <div class="w-full flex flex-col items-center gap-2 p-2 pr-5 text-sigecom-dark-gray-2">
      <h2 class="text-xl text-center font-bold" *ngIf="args?.title">{{ args?.title }}</h2>
      <ng-container *ngIf="args?.description; else defaultMessage">
        <p class="text-base text-center">{{ args?.description }}</p>
      </ng-container>
      <ng-template #defaultMessage>
        <p class="text-lg text-center font-semibold">{{ args?.message }} <span>{{ args?.resourceName || 'este registro' }}</span>?</p>
        <p class="text-sm text-center text-sigecom-gray">Esta ação pode ser irreversível</p>
      </ng-template>
    </div>

    <footer class="w-full m-3">
      <div class="w-full flex justify-end gap-2">
          <button (click)="cancel()" [class]="buttonClass+'bg-white border border-[#dcdcdc] text-[#262626]'">
            {{ args?.cancelText || 'Cancelar' }}
          </button>
          <button (click)="confirm()" [class]="getButtonClass()">
          {{ args?.confirmText || 'Confirmar' }}
          </button>
      </div>
    </footer>
  </div>
</div>

  `,
})
export class ConfirmationModalComponent implements OnInit {
  public args: IConfirmationModal | null = null;

  public buttonClass = `flex-1 py-2 shadow-md rounded-md `

  private open: boolean = true;

  protected readonly modalType = ConfirmationModalType;

  @Input() header?: string;

  constructor(private confirmationModalService: ConfirmationModalService) { }

  ngOnInit(): void {
    this.confirmationModalService.modalOpen$.subscribe((modalIsOpen) => {
      this.open = modalIsOpen;
    });

    this.confirmationModalService.modalArgs$.subscribe((args) => {
      this.args = args;
    });
  }

  confirm(): void {
    if (this.args) {
      this.args.callbackExecuteAction();
    }
    this.endAction();
  }

  cancel(): void {
    this.endAction();
  }

  endAction() {
    this.confirmationModalService.closeModal();
    this.confirmationModalService.clearArgs();
  }

  getButtonClass(): string {
    let str = this.buttonClass+' text-white '
    if (this.args) {
      switch (this.args?.modalType) {
        case ConfirmationModalType.success:
          str += 'bg-sigecom-success';
          break;
        case ConfirmationModalType.danger:
          str += 'bg-sigecom-danger';
          break;
        case ConfirmationModalType.warn:
          str += 'bg-sigecom-warn';
          break;
        case ConfirmationModalType.info:
          str += 'bg-sigecom-info';
          break;
      }
    }
    return str;
  }

  get isOpen(): boolean { return this.open; }
}
